export const DISCOVERY_BASE_URL = process.env.REACT_APP_DISCOVERY_BASE_URL;
export const REACT_APP_SSO_BASE_URL = process.env.REACT_APP_SSO_BASE_URL;
export const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
export const APP_ENV = process.env.REACT_APP_ENV;
export const DRIVER_SIGNUP_URL = process.env.REACT_APP_DRIVER_SIGNUP_URL;
